import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useMingo } from '../context/MingoContext';

/**
 * Redirects to /home when a feature flag is off (with one toast).
 * @param {{ flag: string, children: React.ReactNode }} props
 */
export default function FeatureRoute({ flag, children }) {
  const { isFeatureEnabled, showToast, t } = useMingo();
  const ok = isFeatureEnabled(flag);
  const toasted = useRef(false);

  useEffect(() => {
    if (ok || toasted.current) return;
    toasted.current = true;
    showToast(t('feature.comingSoonToast'));
  }, [ok, showToast, t]);

  if (!ok) return <Navigate to="/home" replace />;
  return children;
}
